import React from "react";
import { Modal, Button } from "react-bootstrap";

interface ErrorModalProps {
  show: boolean;
  title?: string;
  message?: string | React.ReactNode;
  onClose: () => void;
}

const ErrorModal: React.FC<ErrorModalProps> = ({
  show,
  title = "Error",
  message = "An unexpected error occurred.",
  onClose,
}) => (
  <Modal show={show} onHide={onClose} centered>
    <Modal.Header closeButton className="bg-danger text-white">
      <Modal.Title>{title}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <div className="text-dark">
        {typeof message === "string" ? <p>{message}</p> : message}
        <p className="mt-3 mb-0 small text-muted">
          Please refresh the page and try again, or contact{" "}
          <a href="mailto:ServiceDesk@enmax.com">ServiceDesk@enmax.com</a>.
          <br />
          (Assignment group: Collaboration & Productivity Apps)
        </p>
      </div>
    </Modal.Body>
    <Modal.Footer className="justify-content-end">
      <Button variant="light" onClick={onClose}>
        Close
      </Button>
    </Modal.Footer>
  </Modal>
);

export default ErrorModal;